/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */


// API
import { getPersistedData } from "apis/api";


export default async function persistedExpensesDataTable() {


    try {
        const response = await getPersistedData("expenses");
        const persistedExpensesData = JSON.parse(response.body);
        //     console.log(persistedExpensesData);

        const persistedExpensesRows = persistedExpensesData.map((bill) => ({
            attorney: bill?.attorney || "",
            date: bill?.date || "",
            AttorneyOrigination: bill?.AttorneyOrigination || "",
            FirmRevenue: bill?.FirmRevenue || "",
            AttorneyDirectExpenses: bill?.AttorneyDirectExpenses || 0,
            TotalGeneralExpenses: bill?.TotalGeneralExpenses == "" ? "0" : bill?.TotalGeneralExpenses,
            // client_name: bill?.client?.name || "",
            // client_initials: bill?.client?.initials || "",
            // client_type: bill?.client?.type || "",
            // client_etag: bill?.client?.etag || "",
            // responsible_attorney_id: bill?.responsible_attorney?.id,
            // responsible_attorney_etag: bill?.responsible_attorney?.etag || "",
            // responsible_attorney_name: bill?.responsible_attorney?.name || "",
            // originating_attorney_id: bill?.originating_attorney?.id || 0,
            // originating_attorney_etag: bill?.originating_attorney?.etag || "",
            // originating_attorney_name: bill?.originating_attorney?.name || "",
        }));

        const persistedExpensesColumns = [
            { Header: "attorney", accessor: "attorney", align: "center" },
            { Header: "date", accessor: "date", align: "center" },
            { Header: "AttorneyOrigination", accessor: "AttorneyOrigination", align: "center" },
            { Header: "FirmRevenue", accessor: "FirmRevenue", align: "center" },
            { Header: "AttorneyDirectExpenses", accessor: "AttorneyDirectExpenses", align: "center" },
            { Header: "TotalGeneralExpenses", accessor: "TotalGeneralExpenses", align: "center" },


        ];

        return { persistedExpensesColumns, persistedExpensesRows, persistedExpensesData };
    } catch (error) {
        console.error("Error in persistedExpensesTableData:", error);
        return { persistedExpensesRows: [], persistedExpensesColumns: [] };
    }
}
